var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIconRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M60 27.5C60 40.4787 48.3594 51 34 51C31.4611 51 29.0071 50.6711 26.6875 50.0578L20.186 47.5709C20.11 47.5418 20.0384 47.5023 19.9734 47.4535L16.125 44.5654C11.1212 40.2823 8 34.2206 8 27.5C8 14.5213 19.6406 4 34 4C48.3594 4 60 14.5213 60 27.5Z",
    fill: "#F93749"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3172 53.0077L24.0265 52.9306L23.7631 53.0757L13.8706 58.5262C13.704 58.618 13.5 58.4975 13.5 58.3073V47.802V47.4574L13.2385 47.2329C7.99805 42.7352 4.75 36.3907 4.75 29.375C4.75 15.8427 16.8791 4.75 32 4.75C47.1209 4.75 59.25 15.8427 59.25 29.375C59.25 42.9072 47.1209 54 32 54C29.3308 54 26.7527 53.6533 24.3172 53.0077Z",
    stroke: "#F93749",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H33",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39H44",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30H45",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconRed);
export default __webpack_public_path__ + "static/media/chat-icon-red.f71de3838727b85aeadc1d34b675b219.svg";
export { ForwardRef as ReactComponent };